import React from 'react';
import { ProductPageModel } from '../../Types/ProductPageModel';

const ProductPageStructuredData = ({
  productPage,
}: {
  productPage: ProductPageModel;
}) => {
  const product = productPage.productItem;
  const price = product.price;
  const fields =
    productPage.productSpecificationsGroup?.productFields || [];
  const fieldsById = fields.reduce((acc, field) => {
    acc[field.id] = field;
    return acc;
  }, {});
  // Ids for useful categories, (same for all channels)
  const categoryIds = [
    'ItemPrimaryColor',
    'ItemNuance',
    'ItemRoomType',
    'ItemStyle',
  ];

  return (
    <>
      {/* MPN would be the id that is commonly used by everyone for this item */}
      <meta itemProp="mpn" content={product.id} />
      {/* SKU could be the internal variant id in Litium */}
      <meta itemProp="sku" content={product.id} />
      <meta itemProp="name" content={product.name} />
      <meta itemProp="description" content={product.description} />
      {/* Add color */}
      {fieldsById['ItemPrimaryColor'] && (
        <>
          <meta
            itemProp="color"
            content={fieldsById['ItemPrimaryColor']['value']}
          />
        </>
      )}
      {/* Add categories */}
      {categoryIds.map((category, idx) => {
        if (!fieldsById[category]) return null;
        return (
          <meta
            key={idx}
            itemProp="category"
            content={fieldsById[category]['value']}
          />
        );
      })}
      {product.images?.map((img, idx) => (
        <link
          itemProp="image"
          href={img.originalSrc}
          key={`${product.id}-meta-image-${idx}`}
        />
      ))}
      {product.brand && (
        <div
          itemProp="brand"
          itemType="https://schema.org/Brand"
          itemScope
        >
          <meta itemProp="name" content={product.brand} />
        </div>
      )}
      {price && (
        <div
          itemProp="offers"
          itemType="https://schema.org/Offer"
          itemScope
        >
          <meta
            itemProp="price"
            content={
              price.campaignPrice?.priceWithVat?.toString() ??
              price.price?.priceWithVat?.toString()
            }
          />
          <meta itemProp="priceCurrency" content={price.currency.id} />
          {productPage.productItem?.stockStatus?.inStock ? (
            <meta
              itemProp="availability"
              content="https://schema.org/InStock"
            />
          ) : (
            <meta
              itemProp="availability"
              content="https://schema.org/OutOfStock"
            />
          )}
        </div>
      )}
    </>
  );
};

export default ProductPageStructuredData;
